import axios from 'axios';

const CalendarApi = {
  calendar: (values) => {
    return axios.post(`/calendars/`, values);
  },
}

export default CalendarApi;